import { Injectable } from '@angular/core';
import { DeliverySlot } from '@delivery/const';
import { DeliveryActions, OccDeliverySlotsService } from '@delivery/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class DeliverySlotsEffects {
  loadDeliverySlots$: Observable<DeliveryActions.LoadDeliverySlotsSuccess | DeliveryActions.LoadDeliverySlotsFail> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(DeliveryActions.LOAD_DELIVERY_SLOTS),
        map((action: DeliveryActions.LoadDeliverySlots) => action.payload),

        switchMap(({ geoPoint, weight }) =>
          this.occDeliverySlotsService.loadByGeoPoint(geoPoint, weight).pipe(
            map((data: DeliverySlot[]) => new DeliveryActions.LoadDeliverySlotsSuccess(data)),
            catchError((error) => of(new DeliveryActions.LoadDeliverySlotsFail(error))),
          ),
        ),
      ),
    );

  constructor(
    private actions$: Actions,
    private occDeliverySlotsService: OccDeliverySlotsService,
  ) {}
}
